import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || 'https://ulfrtxtrrplygzdbdoab.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || 'sb_publishable_-NAn4E4Nk0Wj6QVyFQ0cng_vReMv3fo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
